import { PipelineTest } from '../PipelineTest';

export function PipelineTestTab() {
  return <PipelineTest />;
}
